document.addEventListener("DOMContentLoaded", () => {
  const counter = document.getElementById("live-counter");
  const start = parseInt(counter.dataset.start, 10) || 0;
  const target = parseInt(counter.dataset.target, 10);
  let current = start;
  let counting = false;
  let animationFrameId;

  function getRandomDelay() {
    return Math.random() * 200 + 50; // 50ms–250ms
  }

  function countUp() {
    if (!counting || current >= target) return;

    current += Math.floor(Math.random() * 10) + 1; // Add 1–10
    if (current > target) current = target;

    counter.textContent = current.toLocaleString();

    animationFrameId = setTimeout(countUp, getRandomDelay());
  }

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      counting = true;
      countUp();
    } else {
      counting = false;
      clearTimeout(animationFrameId);
    }
  }, {
    root: null, // Use viewport
    threshold: 0.25, // Trigger when 25% is visible (more lenient)
    rootMargin: "100px 0px 100px 0px" // Add buffer top & bottom
  });

  observer.observe(counter);
});
